import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import ReportUrl from "./types/ReportUrl";

const baseUrl = "/reports";

const requests = {
    compareInventoriesFetch: (config: AxiosRequestConfig) =>
        api.get(`${baseUrl}/compare-inventories`, config),
    costAndVarianceFetch: (config: AxiosRequestConfig) =>
        api.get(`${baseUrl}/cost-and-variance`, config),
    fetch: (config: AxiosRequestConfig, url: ReportUrl) =>
        api.get(`${baseUrl}/${url.name}`, config),
    download: (
        config: AxiosRequestConfig,
        url: ReportUrl & { format: string },
    ) =>
        api.get(`${baseUrl}/${url.name}/${url.format}`, {
            ...config,
            responseType: "blob",
        }),
};

export default requests;
